<template>
  <el-dialog
      :visible.sync="dialogOpen"
      append-to-body
      :show-close="true"
      :close-on-click-modal="false"
      custom-class="rejection-modal"
      @close="onDialogClose"
      title="Форма добавления"
  >
    <template slot="default">
      <el-form :model="form" :rules="form_rules" ref="Form" v-loading="loading">
        <el-form-item label="Тип статьи" prop="type">
          <el-select v-model="form.type" size="small">
            <el-option
                v-for="item in articleTypes"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
          <div>
            Видимость: <toggle-visibility-btn :id="form.id" :value="form.show" />
          </div>
        </el-form-item>
        <el-form-item>
          <el-tabs type="card" v-model="currentLanguage">
            <el-tab-pane label="Русский" name="ru">
              <span slot="label" :class="{'el-danger-text-color': ruHasErrors}">
                Русский
                <el-tooltip
                    v-if="ruHasErrors"
                    class="item"
                    effect="light"
                    :content="'Имеются ошибки'"
                    placement="top">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </span>

              <el-form-item label="Заголовок" :prop="`translations.ru.title`">
                <el-input type="text" rows="5" v-model="form.translations.ru.title"></el-input>
              </el-form-item>
              <el-form-item label="Краткое описание" :prop="`translations.ru.description`">
                <el-input type="textarea" rows="5" v-model="form.translations.ru.description"></el-input>
              </el-form-item>
              <el-form-item label="Контент" :prop="`translations.ru.body`">
                <vue-editor
                    v-model="form.translations.ru.body"
                />
              </el-form-item>

            </el-tab-pane>
            <el-tab-pane label="Казахский" name="kz">
              <span slot="label" :class="{'el-danger-text-color': kzHasErrors}">
                Казахский
                <el-tooltip
                    v-if="kzHasErrors"
                    class="item"
                    effect="light"
                    :content="'Имеются ошибки'"
                    placement="top">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </span>

              <el-form-item label="Заголовок" :prop="`translations.kz.title`">
                <el-input type="text" rows="5" v-model="form.translations.kz.title"></el-input>
              </el-form-item>
              <el-form-item label="Краткое описание" :prop="`translations.kz.description`">
                <el-input type="textarea" rows="5" v-model="form.translations.kz.description"></el-input>
              </el-form-item>
              <el-form-item label="Контент" :prop="`translations.kz.body`">
                <vue-editor
                    v-model="form.translations.kz.body"
                />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="Английский" name="en">
              <span slot="label" :class="{'el-danger-text-color': enHasErrors}">
                Английский
                <el-tooltip
                    v-if="enHasErrors"
                    class="item"
                    effect="light"
                    :content="'Имеются ошибки'"
                    placement="top">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </span>

              <el-form-item label="Заголовок" :prop="`translations.en.title`">
                <el-input type="text" rows="5" v-model="form.translations.en.title"></el-input>
              </el-form-item>
              <el-form-item label="Краткое описание" :prop="`translations.en.description`">
                <el-input type="textarea" rows="5" v-model="form.translations.en.description"></el-input>
              </el-form-item>
              <el-form-item label="Контент" :prop="`translations.en.body`">
                <vue-editor
                    v-model="form.translations.en.body"
                />
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <button class="btn" @click="save">Сохранить</button>
      <button class="btn" @click="close">Отмена</button>
    </template>
  </el-dialog>
</template>
<script>
import {mapState} from 'vuex'
import {VueEditor} from 'vue2-editor'
import articlesApi from '@/api/articles'
import articles from '@/mixins/articles'
import {actionTypes as articlesActionTypes} from '@/store/modules/articles'
import ApplicationFormError from '@/components/ApplicationFormError'
import ToggleVisibilityBtn from '@/components/Articles/ToggleVisibilityBtn'

export default {
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  mixins: [articles],
  components: {VueEditor, ApplicationFormError, ToggleVisibilityBtn},
  data(){
    return {
      dialogOpen: false,
      loading: false,
      editMode: false,
      createMode: true,
      currentLanguage: 'ru',
      form: {
        slug: '',
        title: '',
        description: '',
        body: '',
        type: 'info',
        translations: {
          ru: {
            language: 'ru',
            title: '',
            description: '',
            body: ''
          },
          kz: {
            language: 'kz',
            title: '',
            description: '',
            body: ''
          },
          en: {
            language: 'en',
            title: '',
            description: '',
            body: ''
          }
        }
    },
      form_rules: {
        slug: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
        title: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
        description: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
        body: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
        type: [{ required: true, message: 'Заполните поле', trigger: 'blur' }],
        translations: {
          ru: {
            title: [{ required: true, message: 'Заполните поле', trigger: 'blur' }],
            description: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
            body: [{ required: true, message: 'Заполните поле', trigger: 'blur' }]
          },
          kz: {
            title: [{ required: true, message: 'Заполните поле', trigger: 'blur' }],
            description: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
            body: [{ required: true, message: 'Заполните поле', trigger: 'blur' }]
          },
          en: {
            title: [{ required: true, message: 'Заполните поле', trigger: 'blur' }],
            description: [{ required: false, message: 'Заполните поле', trigger: 'blur' }],
            body: [{ required: true, message: 'Заполните поле', trigger: 'blur' }]
          },
        }
      },
      ruHasErrors: false,
      kzHasErrors: false,
      enHasErrors: false,
      failedValid: false,
    }
  },
  computed: {
    ...mapState({
      languages: state => state.app.languages
    })
  },
  mounted() {
    if(this.editDialogOpen){
      this.editMode = true
      this.form = this.data
    }
  },
  methods: {
    save(){
      this.ruHasErrors = false
      this.kzHasErrors = false
      this.enHasErrors = false

      this.$refs.Form.validate((valid, fields) => {
        for(let field in fields){
          if(field.includes('ru')) this.ruHasErrors = true
          if(field.includes('kz')) this.kzHasErrors = true
          if(field.includes('en')) this.enHasErrors = true
        }

        if (valid) {
          if(!this.editMode){
            this.$store.dispatch(articlesActionTypes.addItem, this.form).then(() => {
              this.$message({message: 'Сохранено!', type: 'success'})
              this.dialogOpen = false
              this.createDialogOpen = false
            })
          } else {
            this.$store.dispatch(articlesActionTypes.updateItem, this.form).then(() => {
              this.$message({message: 'Сохранено!', type: 'success'})
              this.dialogOpen = false
              this.editDialogOpen = false
              this.editMode = false
            })
          }
        } else {
          this.failedValid = true
          return false;
        }
      })
    },
    close(){
      this.dialogOpen = false
    },
    resetForm(){
      this.form = {
        slug: '',
        title: '',
        description: '',
        body: '',
        type: 'info',
        translations: {
          ru: {
            language: 'ru',
            title: '',
            description: '',
            body: ''
          },
          kz: {
            language: 'kz',
            title: '',
            description: '',
            body: ''
          },
          en: {
            language: 'en',
            title: '',
            description: '',
            body: ''
          }
        }
      }
    },
    onDialogClose(){
      this.resetForm()
      this.dialogOpen = false
      this.createDialogOpen = false
      this.editDialogOpen = false
      this.currentLanguage = 'ru'
    }
  },
  watch: {
    createDialogOpen(value){
      if(value && !this.editDialogOpen){
        this.dialogOpen = true
      }
    },
    editDialogOpen(value){
      if(value && !this.createDialogOpen && this.editItemId){
        this.editMode = true
        this.dialogOpen = true
        this.loading = true
        articlesApi
            .getItem(this.editItemId)
            .then((response) => {
              this.form = response.data
              this.loading = false
            })
      }
    },
    form: {
      deep: true,
      handler(value){
        if(this.failedValid){
          for(let lang in value.translations){
            if(
                value.translations[lang].title
                && value.translations[lang].description
                && value.translations[lang].body
            ) {
              this[`${lang}HasErrors`] = false
            }
          }
        }
      }
    }
  }
}
</script>